import React, { ReactElement, useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import { RightFlex, ModalBackdrop, ModalContainer, styledScrollBars } from "src/gantt/components/common/StyledComponents";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import styled from "styled-components/macro";
import { 
  EDITBOX_BORDER
} from "src/gantt/helpers/Const";
import { GenericButton, SecondaryButton } from "./Buttons";
import "spectre.css/dist/spectre.min.css";
import "spectre.css/dist/spectre-icons.min.css";
import { Dispatch } from "src/rematch/store";
import { addQueryParameter, getConfig, removeQueryParameter } from "src/backend/helpers/urlHelper";
import { getConfigsFromNVSAsync } from "src/backend/services/NamedValueStorageService";

const UICONFIGFORM_MODAL_WIDTH = 400;
const UICONFIGFORM_MODAL_HEIGHT = 100;

const UICONFIGFORM_MODAL_PADDING = 15;
const UICONFIGFORM_MODAL_FOOTER_HEIGHT = 30;
const UICONFIGFORM_MODAL_CONTENT_HEIGHT = UICONFIGFORM_MODAL_HEIGHT - UICONFIGFORM_MODAL_FOOTER_HEIGHT - 2 * UICONFIGFORM_MODAL_PADDING;

const DRAG_HANDLE_CLASSNAME = "dragHandle";

const UIConfigPage = styled.div`
  border: 2px solid ${EDITBOX_BORDER};
  background: white;
  padding:  ${UICONFIGFORM_MODAL_PADDING}px;
  width: ${UICONFIGFORM_MODAL_WIDTH}px;
  height: ${UICONFIGFORM_MODAL_HEIGHT}px;
`;

const ConfigurationEditor = styled.div`
  height: ${UICONFIGFORM_MODAL_CONTENT_HEIGHT}px;
  overflow: auto;
  ${styledScrollBars}
`;

const UIConfigFooter = styled.div`
  height: ${UICONFIGFORM_MODAL_FOOTER_HEIGHT}px;
  padding-top: 5px;
`;

const SettingsRow = styled.div`
  flex: 0 0 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const renderConfigOptions = (configNames: string[]) => {

  const configOptionItems = [];

  for( const config of configNames ) {
    configOptionItems.push(<option key={config} value={config}>{config}</option>);
  }
  return configOptionItems;
}

export const UIConfigForm = (): ReactElement => {

  const { t }      = useTranslation();
  const dispatch   = useDispatch<Dispatch>();
  const dragRef    = useRef<HTMLDivElement>();

  const [uiConfigValue, setUiConfigValue] = useState("dev");
  const [configNames, setConfigNames] = useState<string[]>([ "dev", "date-only" ]);

  useEffect(() => {

    const params       = new URLSearchParams(decodeURIComponent(window.location.search));
    const currentValue = params.get("config");

    if ( currentValue ) {
      setUiConfigValue( currentValue );
    }

    const fetchConfigsAsync = async () => {

      const baseConfig = await getConfig();
      const configs    = await getConfigsFromNVSAsync(baseConfig);

      if ( configs?.names ) {
        setConfigNames( configs.names );
      }
    };

    fetchConfigsAsync();

  }, [])

  const toggleVisibility = () => {
    dispatch.UI.toggleShowUIConfigForm();
  }

  const handleUIConfigChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    // const inputEvent = event as React.ChangeEvent<HTMLElement> as React.ChangeEvent<HTMLInputElement>;
    const value = event.target.value;
    setUiConfigValue( value );
  } 


  const onFormSubmit = (_event ) => {

    const currentUrl = window.location.href;

    let url = currentUrl;

    if ( currentUrl.includes('?') ) {
      url = removeQueryParameter(currentUrl, "config");
    }

    url = addQueryParameter(url, "config", uiConfigValue);

    window.location.href = url
  }

  return (
    <div>
      <Draggable nodeRef={dragRef} handle={`.${DRAG_HANDLE_CLASSNAME}`}>
        <ModalContainer ref={dragRef} style={{ top: "50%", marginTop: -UICONFIGFORM_MODAL_HEIGHT / 2, left: "50%", marginLeft: -UICONFIGFORM_MODAL_WIDTH / 2 }}>
          <UIConfigPage>
            <ConfigurationEditor id="editor_holder" >
              <SettingsRow>
                <label htmlFor="select">{ t("usermenu.changeuiconfig") }</label>
                <select id="select" name="uiConfig" style={{width: "180px"}} value={uiConfigValue} onChange={handleUIConfigChange}>
                  {renderConfigOptions( configNames )}
                </select>
              </SettingsRow>
            </ConfigurationEditor>
            <UIConfigFooter>
              <RightFlex>
                <SecondaryButton width={80} height={25} style={{ marginRight: "20px" }} onClick={toggleVisibility}>
                  {t("command.close")}
                </SecondaryButton>
                <GenericButton id="submit" width={80} height={25} onClick={onFormSubmit}> 
                  {t("command.save")}
                </GenericButton>
              </RightFlex>
            </UIConfigFooter>
          </UIConfigPage>
        </ModalContainer>
      </Draggable>
      <ModalBackdrop onClick={toggleVisibility}></ModalBackdrop>
    </div>
  );

}